import styled from "styled-components";
import { Flex } from "antd";

export const StyledAuth = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 50px;
  padding-top: 160px;
  background-color: rgba(251, 247, 240, 1);
  opacity: 1;
  transition: opacity 300ms ease-in-out;

  &.fade-out {
    opacity: 0;
  }
`;

export const ContentWrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
  width: 500px;
`;

export const OrangeLine = styled.div`
  width: 8px;
  height: 80px;
  background-color: orange;
  margin-right: 24px;
`;

export const TextBlock = styled(Flex)`
  align-items: center;
  justify-content: flex-start;
`;
